<ngx-spinner name="NgCareNet" size="large" fullScreen="true" type="">
  <div id="loader-wrapper">
    <div id="loader"></div>
  </div>
</ngx-spinner>
<p-toast position="top-right"></p-toast>
<router-outlet></router-outlet>
